module.exports = __webpack_public_path__ + "static/media/IMG_8631.7e1e87fd.jpg";